import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the surveys state domain
 */

const selectSurveysDomain = (state) => state.get("surveys", initialState)

export const makeSelectSurveys = () =>
  createSelector(selectSurveysDomain, (state) => state.get("activeSurveys"))

export const makeSelectLeadershipSurveys = () =>
  createSelector(selectSurveysDomain, (state) => state.get("leadershipSurveys"))

export const makeSelectIsLoadingSurveys = () =>
  createSelector(selectSurveysDomain, (state) => state.get("isLoadingSurveys"))

//  GET SURVEY
export const makeSelectIsLoadingSurvey = () =>
  createSelector(selectSurveysDomain, (state) => state.get("isLoadingSurvey"))

export const makeSelectGetSurvey = () =>
  createSelector(selectSurveysDomain, (state) => state.get("survey"))

export const makeSelectGetSurveyName = () =>
  createSelector(selectSurveysDomain, (state) => state.get("surveyName"))

export const makeSelectSegments = () =>
  createSelector(selectSurveysDomain, (state) => state.get("segments"))

export const makeSelectIsLoadingSegments = () =>
  createSelector(selectSurveysDomain, (state) => state.get("isLoadingSegments"))

export const makeSelectSurveyTypes = () =>
  createSelector(selectSurveysDomain, (state) => state.get("surveyTypes"))

export const makeSelectIsLoadingSurveyTypes = () =>
  createSelector(selectSurveysDomain, (state) =>
    state.get("isLoadingSurveyTypes")
  )

export const makeSelectScopeTypes = () =>
  createSelector(selectSurveysDomain, (state) => state.get("scopeTypes"))

export const makeSelectIsLoadingScopeTypes = () =>
  createSelector(selectSurveysDomain, (state) =>
    state.get("isLoadingScopeTypes")
  )
//  GET SURVEYS TEMPLATE
export const makeSelectIsLoadingSurveysTemplate = () =>
  createSelector(selectSurveysDomain, (state) =>
    state.get("isLoadingSurveysTemplate")
  )

export const makeSelectSurveysTemplate = () =>
  createSelector(selectSurveysDomain, (state) => state.get("surveysTemplate"))

// GET SURVEY ENPS
export const makeSelectIsLoadingSurveyEnps = () =>
  createSelector(selectSurveysDomain, (state) =>
    state.get("isLoadingSurveyEnps")
  )

export const makeSelectSurveyEnps = () =>
  createSelector(selectSurveysDomain, (state) => state.get("surveyEnps"))

// GET SURVEY ENPS
export const makeSelectIsLoadingSurveyQualitative = () =>
  createSelector(selectSurveysDomain, (state) =>
    state.get("isLoadingSurveyQualitative")
  )

export const makeSelectSurveysByIndicators = () =>
  createSelector(selectSurveysDomain, (state) =>
    state.get("surveysByIndicators")
  )

export const makeSelectSurveyQualitative = () =>
  createSelector(selectSurveysDomain, (state) => state.get("surveyQualitative"))
/**
 * Other specific selectors
 */

/**
 * Default selector used by Surveys
 */

export { selectSurveysDomain }
